import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Confirm, Empty } from "@/pages/admin/managers/ui";
import { Trash2, Mail } from "lucide-react";

export default function MessagesManager() {
  const [items, setItems] = useState([]);
  const [confirmId, setConfirmId] = useState(null);

  const load = async () => setItems((await api.get("/admin/contact-messages")).data);
  useEffect(() => { load(); }, []);

  const del = async () => { await api.delete(`/admin/contact-messages/${confirmId}`); toast.success("Mensaje eliminado."); setConfirmId(null); load(); };

  return (
    <div>
      {items.length === 0 ? <Empty>No hay mensajes de contacto.</Empty> : (
        <div className="space-y-3">
          {items.map((m) => (
            <div key={m.id} data-testid={`message-row-${m.id}`} className="bg-[#18181B] border border-[#27272A] rounded-lg p-5">
              <div className="flex justify-between gap-3">
                <div>
                  <p className="text-white font-medium">{m.name}</p>
                  <p className="text-xs text-[#8C8375]">{m.email} {m.phone && `· ${m.phone}`} {m.event_type && `· ${m.event_type}`}</p>
                </div>
                <div className="flex items-start gap-3">
                  <a href={`mailto:${m.email}`} className="text-[#A1A1AA] hover:text-[#C5A059]"><Mail size={16} /></a>
                  <button data-testid={`message-delete-${m.id}`} onClick={() => setConfirmId(m.id)} className="text-[#A1A1AA] hover:text-red-400"><Trash2 size={16} /></button>
                </div>
              </div>
              <p className="mt-3 text-sm text-[#E4E4E7] bg-[#0F0F10] rounded p-3">{m.message}</p>
            </div>
          ))}
        </div>
      )}
      <Confirm open={!!confirmId} onClose={() => setConfirmId(null)} onConfirm={del} message="¿Eliminar este mensaje?" />
    </div>
  );
}
